export const isMobileWidth = () =>
  window.screen.width < window.MOBILE_WIDTH_RESOLUTION_PHONE ||
  window.innerWidth < window.MOBILE_WIDTH_RESOLUTION_PHONE;
